import { ActionType } from '@/enums/actionType';
import type { NoteColor } from '@/enums/noteColor';
import type {
  CreatePayload,
  MovePayload,
  Note,
  NoteId,
  NotesAction,
  ResizePayload,
} from '@/types/note';

export const hydrate = (notes: readonly Note[]): NotesAction => ({
  type: ActionType.Hydrate,
  payload: { notes },
});

export const create = (payload: CreatePayload): NotesAction => ({
  type: ActionType.Create,
  payload,
});

export const move = (payload: MovePayload): NotesAction => ({
  type: ActionType.Move,
  payload,
});

export const resize = (payload: ResizePayload): NotesAction => ({
  type: ActionType.Resize,
  payload,
});

export const deleteNote = (id: NoteId): NotesAction => ({
  type: ActionType.Delete,
  payload: { id },
});

export const updateText = (id: NoteId, text: string): NotesAction => ({
  type: ActionType.UpdateText,
  payload: { id, text },
});

export const updateColor = (id: NoteId, color: NoteColor): NotesAction => ({
  type: ActionType.UpdateColor,
  payload: { id, color },
});

export const bringToFront = (id: NoteId): NotesAction => ({
  type: ActionType.BringToFront,
  payload: { id },
});

export const reconcileFromServer = (note: Note): NotesAction => ({
  type: ActionType.ReconcileFromServer,
  payload: { note },
});

export const rollbackOptimistic = (id: NoteId, previous: Note | null): NotesAction => ({
  type: ActionType.RollbackOptimistic,
  payload: { id, previous },
});

export const undo = (): NotesAction => ({ type: ActionType.Undo });
export const redo = (): NotesAction => ({ type: ActionType.Redo });
